/* eslint-disable */
export default [
  {
    path: "/task-management",
    name: "task-management-all-stuatus",
    component: () => import("@/views/task-management-new/TaskManagments.vue")
  }
];
